import Vue from 'vue'
const state = {
    recordId: '',
}

// getters
const getters = {}

// actions
const actions = {
  setBookId({ commit }, id) {
        commit('update', { recordId: id })
    },
}

// mutations
const mutations = {
    // update: (state, id) => {
    //     state.recordId = id
    // }
    update(state, payload) {
        console.log('22', state, payload)
        for (const key in payload) {
            Vue.set(state, key, payload[key])
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
